import type { Car } from "@/types/car";
import type { Performance, PerformanceData } from "@/types/performance";

export function getPerformanceCarName(car?: Car, fallback = "-") {
  if (car) {
    const base = `${car.make} - ${car.model}${car.nickname ? ` (${car.nickname})` : ""}`;
    return car.identifier ? `${base}\u200B${car.identifier}` : base;
  }
  return fallback;
}

export function getPerformanceCarChartData(
  car1?: Performance,
  car2?: Performance
): [PerformanceData[], PerformanceData[]] {
  const car1PerformanceData = car1?.performance.data || [];
  const car2PerformanceData = car2?.performance.data || [];

  const paddedCar1Data = getPaddedData(car1PerformanceData, car2PerformanceData);
  const paddedCar2Data = getPaddedData(car2PerformanceData, car1PerformanceData);

  return [paddedCar1Data, paddedCar2Data];
}

function getPaddedData(data: PerformanceData[], targetData: PerformanceData[]) {
  if (targetData.length > data.length) {
    return [
      ...targetData.slice(0, targetData.length - data.length).map((d) => ({ ...d, value: 0 })),
      ...data,
    ];
  }
  return data;
}
